// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmploymentContract  {
    _originalTypeClassName = "Loom.BO.EmploymentContract";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmploymentContract.translate = translateService;
}
this.ContractWorkDays = [];
this.Payments = [];
this.Benefits = [];
this.Id = null;
this.EmployeeAndCompany = null;
this.StartDate = null;
this.EndDate = null;
this.ContractEndDate = null;
this.Position = null;
this.JobDescription = null;
this.NetAmount = null;
this.GrossAmount = null;
this.EmployerTotalCost = null;
this.HourlyRate = null;
this.WeeklyHours = null;
this.TradingAsDifferentEntity = false;
this.MaxAnnualHours = null;
this.MaxMonthlyHours = null;
this.UI_IsExpanded = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
EmployeeAndCompany:any;
StartDate:any;
EndDate:any;
ContractEndDate:any;
Position:any;
JobDescription:any;
NetAmount:any;
GrossAmount:any;
EmployerTotalCost:any;
HourlyRate:any;
WeeklyHours:any;
TradingAsDifferentEntity:any;
MaxAnnualHours:any;
MaxMonthlyHours:any;
UI_IsExpanded:any;
Employee:any;
EmploymentType:any;
InvoicingEntity:any;
ContractWorkDays:any;
Payments:any;
Benefits:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeEmploymentContracts(oldValue, $this);
}
Domain.Employee.addEmploymentContracts(value, $this);
}
}
static setEmploymentType = ($this, value) => {
var oldValue = $this.EmploymentType;
$this.EmploymentType = value;
if (value != null) {
}
}
static setInvoicingEntity = ($this, value) => {
var oldValue = $this.InvoicingEntity;
$this.InvoicingEntity = value;
if (value != null) {
if (oldValue != null && oldValue.EmploymentContract != null) { oldValue.EmploymentContract = null; }
if ($this.InvoicingEntity.EmploymentContract !== $this) {
Domain.InvoicingEntity.setEmploymentContract(value, $this);
}
}
}
static setContractWorkDays = ($this, items) => {
                if (items == null) items = [];
                if ($this.ContractWorkDays == null) $this.ContractWorkDays = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ContractWorkDays.length > 0) {
                    Domain.EmploymentContract.removeContractWorkDays($this, $this.ContractWorkDays[0]);
                }

                Domain.EmploymentContract.addManyContractWorkDays($this, copyItems);
            }
static addManyContractWorkDays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContract.addContractWorkDays($this, items[i]);
                }
            }
static addContractWorkDays = ($this, item) => {
                if ($this.ContractWorkDays == null) $this.ContractWorkDays = [];
                if (item == null || $this.ContractWorkDays.indexOf(item) > -1) return;
                $this.ContractWorkDays.push(item);
}
static addRangeContractWorkDays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContract.addContractWorkDays($this, item));
            }
static removeContractWorkDays = ($this, item) => {
                if ($this == null || $this.ContractWorkDays == null || $this.ContractWorkDays.indexOf(item) === -1) return;
                var _index = $this.ContractWorkDays.indexOf(item);
                $this.ContractWorkDays.splice(_index, 1);
}
static clearContractWorkDays = ($this) => { $this.ContractWorkDays = null; }
static setPayments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Payments == null) $this.Payments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Payments.length > 0) {
                    Domain.EmploymentContract.removePayments($this, $this.Payments[0]);
                }

                Domain.EmploymentContract.addManyPayments($this, copyItems);
            }
static addManyPayments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContract.addPayments($this, items[i]);
                }
            }
static addPayments = ($this, item) => {
                if ($this.Payments == null) $this.Payments = [];
                if (item == null || $this.Payments.indexOf(item) > -1) return;
                $this.Payments.push(item);
if (item.Contract != $this) {
Domain.SalaryPayment.setContract(item, $this);
}
}
static addRangePayments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContract.addPayments($this, item));
            }
static removePayments = ($this, item) => {
                if ($this == null || $this.Payments == null || $this.Payments.indexOf(item) === -1) return;
                var _index = $this.Payments.indexOf(item);
                $this.Payments.splice(_index, 1);
item.Contract = null;
}
static clearPayments = ($this) => { $this.Payments = null; }
static setBenefits = ($this, items) => {
                if (items == null) items = [];
                if ($this.Benefits == null) $this.Benefits = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Benefits.length > 0) {
                    Domain.EmploymentContract.removeBenefits($this, $this.Benefits[0]);
                }

                Domain.EmploymentContract.addManyBenefits($this, copyItems);
            }
static addManyBenefits = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.EmploymentContract.addBenefits($this, items[i]);
                }
            }
static addBenefits = ($this, item) => {
                if ($this.Benefits == null) $this.Benefits = [];
                if (item == null || $this.Benefits.indexOf(item) > -1) return;
                $this.Benefits.push(item);
}
static addRangeBenefits = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.EmploymentContract.addBenefits($this, item));
            }
static removeBenefits = ($this, item) => {
                if ($this == null || $this.Benefits == null || $this.Benefits.indexOf(item) === -1) return;
                var _index = $this.Benefits.indexOf(item);
                $this.Benefits.splice(_index, 1);
}
static clearBenefits = ($this) => { $this.Benefits = null; }

static GetFullTimeEquivalentFactor($this: any): any{if (($this?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.ActualCosts || $this?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.UnitCosts)) {let fullTimeWeeklyHours = $this?.Employee?.Organisation?.FullTimeWeeklyHours;if ((CLMS.Framework.Number.LessThanOrEqual(() => fullTimeWeeklyHours, () => 0))) {fullTimeWeeklyHours = 40.0;}if ((CLMS.Framework.Number.GreaterThan(() => $this.WeeklyHours, () => 0))) {return Joove.Common.safeNumber($this?.WeeklyHours) / Joove.Common.safeNumber(fullTimeWeeklyHours);}if ((CLMS.Framework.Number.GreaterThan(() => $this.MaxMonthlyHours, () => 0))) {return Joove.Common.safeNumber($this?.MaxMonthlyHours) * Joove.Common.safeNumber(12.0) / Joove.Common.safeNumber(1720.0);}return 1.0;}else if (($this?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.HourlyRate)) {if ((CLMS.Framework.Number.GreaterThan(() => $this.MaxAnnualHours, () => 0))) {return Joove.Common.safeNumber($this?.MaxAnnualHours) / Joove.Common.safeNumber(1720.0);}if ((CLMS.Framework.Number.GreaterThan(() => $this.MaxMonthlyHours, () => 0))) {return Joove.Common.safeNumber($this?.MaxMonthlyHours) * Joove.Common.safeNumber(12.0) / Joove.Common.safeNumber(1720.0);}let fullTimeWeeklyHours = $this?.Employee?.Organisation?.FullTimeWeeklyHours;if ((CLMS.Framework.Number.LessThanOrEqual(() => fullTimeWeeklyHours, () => 0))) {fullTimeWeeklyHours = 40.0;}if ((CLMS.Framework.Number.GreaterThan(() => $this.WeeklyHours, () => 0))) {return Joove.Common.safeNumber($this?.WeeklyHours) / Joove.Common.safeNumber(fullTimeWeeklyHours);}return 1.0;}else if (($this?.EmploymentType?.CostCalculationType == Domain.ECCostCalculationTypes.TimeAndMaterial)) {return 0.0;}
throw Error("Could not determine FTE for employee: " + $this?.EmployeeAndCompany + ", contract: " + $this?.StartDate);
}
static GetNameAndCompany($this: any): any{return CLMS.Framework.String.Format("{0} ({1})", $this?.Employee?.Person?.FullName, $this?.Employee?.Organisation?.ShortName);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}